<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="hrissecondary"
        class="white--text px-10"   
        v-on="on"
      >
        Import Transactions
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Payroll Detail"
      text="Upload Transactions"
      class="mb-0"
    > 
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col :cols="file?'12':10">
              <helper-file-input
                v-model="file" 
                v-validate="'required'" 
                :max-size-in-mb="2"
                :max-number="1"
                data-vv-name="file"
                field-name="file"
                accept-type=".xlsx,.xls,.csv"    
                extension="ext:xlsx,xls,csv"         
              >
                <div 
                  slot="activator"
                  class="mb-2"
                >   
                  <v-row>
                    <v-col>
                      <v-btn                    
                        :disabled="progressing"
                        class="mx-2"    
                      >
                        Add file
                      </v-btn>
                      <span> 
                        {{ file ? '' : 'No file chosen (.xlsx, .xls, .csv only)' }}
                      </span>
                    </v-col>
                    <v-col
                      v-if="file"
                      cols="10"
                      class="px-2"
                    >
                      <span
                        v-for="(selectedFile, i) in file.selectedFiles"
                        :key="selectedFile.name"
                        class="font-weight-bold"
                      > {{ selectedFile.name }} {{ (i + 1) === file.selectedFiles.length ? '' : ',' }} </span>
                    </v-col>
                  </v-row>
                </div>
              </helper-file-input>
              <span class="red--text text--lighten-1 caption">{{ errors.first('file') }}</span>
            </v-col>
            <v-col
              v-if="!file"
              cols="2"
              class="pt-6"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on: tooltip }">
                  <v-btn
                    href="/templates/Payroll Cycle Transaction Template.xlsx"
                    color="hrissuccess"
                    dark
                    icon
                    medium
                    v-on="{ ...tooltip }"
                  >
                    <v-icon class="mr-1">
                      mdi-download
                    </v-icon>
                  </v-btn>
                </template>
                <span>Download Transaction Import Template</span>
              </v-tooltip>
            </v-col>
          </v-row>

          <v-row v-if="errorImporting">
            <v-col cols="12">
              <span style="color:red;font-size:15px;font-weight:900">Error! Import Failed.</span> 
            </v-col>

            <v-col
              cols="12"
              class="py-0"
              :class="{
                'overflow': failed.length>0,
              }"
              data-simplebar
            >
              <div
                v-for="(item,i) in failed"
                :key="i"
              >
                <span style="color:red">
                  {{ item }}
                </span>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </form>
      
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"      
          color="hrissecondary"
          class="white--text px-10"   
          @click="submitForm"
        >
          Import 
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    components: {
      HelperFileInput: () => import('@/components/helper/FileInput'),
    },
    props: {
      payrollCycleTransaction: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        progressing: false,
        dialog: null,
        file: null,
        errorImporting: false,
        failed: [],
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return       
        this.resetForm()
      },
    },
    methods: { 
      prepareFormData () {
        if (this.file) {
          return this.file.formData
        }
      },   
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.progressing = true
            this.errorImporting = false
    
            this.$api.payrollCycleTransactions().import(this.payrollCycleTransaction.id, this.prepareFormData())
              .then((response) => {
                this.$emit('imported')                
                this.$snack({ message: response.data.status })

                this.progressing = false
                this.dialog = false  
              }).catch(e => {
                this.errorImporting = true
                if (e.response.status === 422) {
                  this.failed = e.response.data.status
                } else if (e.response.status === 409) {
                  this.failed = [e.response.data.message]
                }
                
                this.progressing = false
              })
          })
      },

      resetForm () {
        this.$validator.reset()
        this.file = null
        this.successfullyImported = false
        this.errorImporting = false
        this.failed = []
      },
    },
  }
</script>

<style scoped>
  .overflow {
    height:10vh;
  }
</style>
